<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="relative">
        <mat-icon [svgIcon]="'heroicons_outline:cog-6-tooth'"></mat-icon>
        <span class="absolute bottom-0 right-0 h-2 w-2 rounded-full"></span>
    </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <button mat-menu-item disabled>
        <span class="flex flex-col leading-none text-black dark:text-white">
            <span>Correo Electrónico</span>
            <span class="mt-1.5 text-md font-medium">{{ user.email }}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="openChangePasswordModal()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-path'"></mat-icon>
        <span>Cambie su contraseña</span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="signOut()">
        <mat-icon
            [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
        ></mat-icon>
        <span>Cerrar sesión</span>
    </button>
</mat-menu>
